// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/rules-of-hooks */
import { Logo150 } from "../../assets/images";
import { Box, IconButton, Stack, Typography, Link, useTheme, useMediaQuery } from "@mui/material";
// import {

//   UserIcon,
// } from "../../assets/icons";
import { NavigationItem } from "../molecules";
import { useRecoilState } from 'recoil';
import { initialUserInfoState, useUserInfo } from "../../store/User.state";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import { StorageKeys } from "../../common/storageKeys";
import { useGetUserMenuList, useLogout } from "../../hooks";
import DashboardIcon from '@mui/icons-material/Dashboard';
import * as Icons from '@mui/icons-material';
import { useSetSnackBar } from "../../store/Snackbar.state";
import { useEffect, useState } from "react";
import { sidebarState } from '../../store/FirstLoad.state';
import { motion } from 'framer-motion';

export type SidebarProps = {
  onCloseMenu?: () => void;
}
const variants = {
  hidden: { opacity: 0, x: -100 },
  visible: (i) => ({
    opacity: 1,
    x: 0,
    transition: {
      delay: i * 0.2, // Her bir öğe için 0.2 saniye artan gecikme
    },
  }),
};

export const Sidebar = ({ onCloseMenu }: SidebarProps) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const setSnackbar = useSetSnackBar();
  const { data: userMenu } = useGetUserMenuList();
  const [userInfo, setUserInfo] = useUserInfo();
  const { mutate: logout } = useLogout();
  const navigate = useNavigate();
  const [isFirstLoad, setIsFirstLoad] = useRecoilState(sidebarState);
  useEffect(() => {
    if (isFirstLoad) {
      setTimeout(() => {
        setIsFirstLoad(false);
      }, 2000);
    }
  }, [isFirstLoad]);

  const handleLogout = () => {
    logout({}, {
      onSuccess: () => {
        setUserInfo(initialUserInfoState);
        localStorage.setItem(StorageKeys.bearerToken, "");
        localStorage.setItem(StorageKeys.expireDate, "");
        navigate("/");
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      }
    });
  };


  const getShortName = (name: string) => {
    const splittedName = name.split(" ");
    const size = splittedName.length;
    if (size > 1)
      return (
        splittedName[0]?.charAt(0).toUpperCase() +
        splittedName[size - 1].charAt(0).toUpperCase()
      );

    return "";
  };
  return (
    <Box
      maxWidth={isDesktop ? 260 : undefined}
      width={isDesktop ? 260 : undefined}
      sx={{
        position: 'fixed', // Make sidebar fixed
        height: '100vh',
        left: 0,
        top: 0,
      }}
    >
      <Stack
        sx={{
          borderRight: "1px solid #EFEFEF",
          backgroundColor: "white",
          px: 0,
          pt: isDesktop ? 2 : 0,
          height: '100%',
          overflow: 'auto', // Prevent sidebar scrolling
          justifyContent: "space-between",
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
        }}
      >
        <Stack>
          {isDesktop && (
            <Stack
              alignItems={isDesktop ? "center" : 'space-between'}
              justifyContent={isDesktop ? "center" : 'space-between'}
              pb={isDesktop ? 2 : 0}
              direction={isDesktop ? "column" : 'row'}
              borderBottom="1px solid #C0C0C7"
              height={isDesktop ? 100 : 'auto'}
              px={2}
            >
              <RouterLink to="/dashboard">
                <img width={isDesktop ? 150 : 50} src={Logo150} alt="logo" />
              </RouterLink>
            </Stack>
          )}
          <Stack sx={{
            pt: 1
          }}>
            <motion.div
              custom={0}
              variants={variants}
              initial={isFirstLoad ? "hidden" : "visible"}
              animate="visible"
            >
              <NavigationItem
                url="dashboard"
                title="Ana Ekran"
                Icon={DashboardIcon}
              />
            </motion.div>

            {userMenu?.data?.map((menuItem, index) => {
              const IconComponent = Icons[menuItem.icon as keyof typeof Icons];
              return (
                <motion.div
                  key={menuItem.id}
                  custom={index + 1}
                  variants={variants}
                  initial={isFirstLoad ? "hidden" : "visible"}
                  animate="visible"
                >
                  <NavigationItem
                    url={menuItem.id}
                    title={menuItem.title}
                    Icon={IconComponent}
                    navItems={
                      menuItem?.childs
                        ? menuItem?.childs?.map((childItem) => {
                          return {
                            text: childItem.title,
                            url: `${menuItem.id}/${childItem.id}`,
                            children: childItem?.childs?.length
                              ? childItem.childs.map((grandChild) => ({
                                text: grandChild.title,
                                url: `${menuItem.id}/${grandChild.id}`,
                              }))
                              : undefined,
                          };
                        })
                        : undefined
                    }
                  />
                </motion.div>
              );
            })}

          </Stack>
        </Stack>
        <Stack
          sx={{ borderTop: "1px solid #C0C0C7", py: 3, cursor: "pointer", px: 2 }}
          direction="row"
        >
          <Stack
            sx={{
              mr: 1,
              width: 38,
              height: 38,
              borderRadius: 20,
              backgroundColor: "#0C9FDC",
              justifyContent: "center",
              alignItems: "center",

            }}
          >
            <Typography color={'#fff'} variant="h5">
              {getShortName(userInfo.fullName)}
            </Typography>
          </Stack>
          <Stack
            flex={1}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box>
              <Typography sx={{ lineHeight: 1.25 }} color={'text.subtle'} variant='body2'>
                {userInfo.fullName}
              </Typography>
            </Box>
            <IconButton onClick={handleLogout}>
              <ExitToAppIcon color="action" />
            </IconButton>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};
